import React from "react"
import GetChallengeViewModel from "../Shared/ViewModels/GetChallengeViewModel"
import QaiChallengeResponseDialog from "../Shared/QaiChallengeResponseDialog"

interface ITeamLeaderQaiResponseContainerProps {
    view: string
    open: boolean
    challenge: GetChallengeViewModel
    setChallenge: (value: GetChallengeViewModel | null) => void
    getChallenges: () => void
    getChallengedQuestions: () => void
}

export default function TeamLeaderQaiResponseContainer({ view, open, challenge, setChallenge, getChallenges, getChallengedQuestions }: ITeamLeaderQaiResponseContainerProps) {

    const close = () => {
        setChallenge(null);
    }

    const refresh = () => {
        getChallenges()
        getChallengedQuestions();
    }

    return (
        <QaiChallengeResponseDialog
            view={view}
            open={open}
            close={close}
            refresh={refresh}
            action='UpdateChallengeResponse'
            id={challenge.id}
            name={challenge.name}
            note={challenge.note}
        />
    )
}